var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.route)?_c('router-link',{staticClass:"link",class:_vm.setColor,attrs:{"to":_vm.route},nativeOn:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }